import React from "react";
import { formatRangeVal, getExposure, bookClass, bookText, isSuspended } from "../../casinoComponents/userSiteLastResult/refUtils";
import { RefRemark } from "../../casinoComponents/userSiteLastResult/refBits";

const BASE = import.meta.env.BASE_URL;
const SUIT = `${BASE}img/cardIcons`;
const CARD = (c) => `${BASE}img/cards/${c}.png`;
const ALPHABETS = ["A", "B", "C", "D", "E", "F"];

const bySr = (a, b) => Number(a?.sr) - Number(b?.sr);

/**
 * Bollywood Casino (btable / btable2) bet area in the reference markup (inside .casino-detail; isTablet template):
 *   .row.row5.d-none-small (6 × .col-4 films back/lay + book, + range)
 *   .row.row5 (.col-lg-4 Odd back/lay, 2 × .col-lg-4.bc-fancy Dulha Dulhan K-Q / Barati J-A)
 *   .row.row5 (.col-lg-6.aaa-oe Red / Black, .col-lg-6 Cards J Q K A)
 *   + .casino-remark. Markets by subtype: btable (films), btablefancy (Red, Black, J, Q, K, A, Dulha, Barati),
 *   btablefancy1 (Odd), each sorted by sr.
 */
export default function BtableLiveTable({ raw = {}, exposures = {} }) {
  const sub = Array.isArray(raw?.sub) ? raw.sub : [];
  const main = sub.filter((s) => s?.subtype === "btable").sort(bySr);
  const fancy = sub.filter((s) => s?.subtype === "btablefancy").sort(bySr);
  const fancy1 = sub.filter((s) => s?.subtype === "btablefancy1").sort(bySr);
  const susp = (m) => (isSuspended(m) ? " suspended" : "");
  const book = (m, tag = "div") => {
    const exp = getExposure(exposures, m?.nat);
    return React.createElement(tag, { className: `casino-book text-center ${bookClass(exp)}` }, bookText(exp));
  };
  const minMax = (m, extra = " w-100") => (
    <div className={`teen1daycasino-container justify-content-end casino-min-max${extra}`}>
      <div>
        R:<span>{formatRangeVal(m?.min)}</span> - <span>{formatRangeVal(m?.max)}</span>
      </div>
    </div>
  );
  const backLay = (m) => (
    <div className="casino-bl-box">
      <div className={`back casino-bl-box-item${susp(m)}`}>
        <span className="casino-box-odd">{m?.b}</span>
      </div>{" "}
      <div className={`lay casino-bl-box-item${susp(m)}`}>
        <span className="casino-box-odd">{m?.l}</span>
      </div>
    </div>
  );
  const bcFancy = (m, label) => (
    <div className="col-lg-4 col-6 bc-fancy">
      <div className="casino-box-row">
        <div className="casino-nation-name">
          <b>{m?.b}</b>
        </div>{" "}
        <div className="casino-bl-box">
          <div className={`back casino-bl-box-item${susp(m)}`}>
            <span className="casino-box-odd">{label}</span>
          </div>{" "}
          {book(m, "span")}
        </div>
      </div>{" "}
      {minMax(m)}
    </div>
  );
  const colorBox = (m, suits) => (
    <div className="casino-bl-box">
      <div className={`back casino-bl-box-item casino-card-img${susp(m)}`}>
        <span>
          <img src={`${SUIT}/${suits[0]}.png`} alt="" /> <img src={`${SUIT}/${suits[1]}.png`} alt="" />
        </span>
      </div>{" "}
      {book(m, "span")}
    </div>
  );

  return (
    <>
      <div className="row row5 d-none-small">
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <div className="col-4" key={i}>
            <div className="casino-box-row">
              <div className="casino-nation-name">
                <b>{`${ALPHABETS[i]}. ${main[i]?.nat ?? ""}`}</b>
              </div>{" "}
              {backLay(main[i])} {book(main[i])}
            </div>
          </div>
        ))}{" "}
        <div className="col-12">{minMax(main[0], "")}</div>
      </div>{" "}
      <div className="row row5">
        <div className="col-lg-4 col-12 d-none-small">
          <div className="casino-box-row">
            <div className="casino-nation-name">
              <b>Odd</b>
            </div>{" "}
            {backLay(fancy1[0])} {book(fancy1[0])} {minMax(fancy1[0])}
          </div>
        </div>{" "}
        {bcFancy(fancy[6], "Dulha Dulhan K-Q")} {bcFancy(fancy[7], "Barati J-A")}
      </div>{" "}
      <div className="row row5">
        <div className="col-lg-6 col-12 aaa-oe">
          <div className="casino-box-row">
            <div className="casino-bl-box">
              <b>{fancy[0]?.b}</b>
            </div>{" "}
            <div className="casino-bl-box">
              <b>{fancy[1]?.b}</b>
            </div>
          </div>{" "}
          <div className="casino-box-row">
            {colorBox(fancy[0], ["heart", "diamond"])} {colorBox(fancy[1], ["spade", "club"])}
          </div>{" "}
          {minMax(fancy[0])}
        </div>{" "}
        <div className="col-lg-6 col-12">
          <div className="text-center w-100">
            <div className="casino-bl-box">
              <div className="casino-bl-box-item">
                <b>{`Cards ${fancy[2]?.b ?? ""}`}</b>
              </div>
            </div>
          </div>{" "}
          <div className="casino-cards text-center mt-1">
            {["J", "Q", "K", "A"].map((c, i) => (
              <React.Fragment key={c}>
                {i > 0 && " "}
                <div className="casino-card-item">
                  <div className={`card-image${susp(fancy[i + 2])}`}>
                    <img src={CARD(c)} alt="" />
                  </div>{" "}
                  {book(fancy[i + 2])}
                </div>
              </React.Fragment>
            ))}
          </div>{" "}
          {minMax(fancy[2])}
        </div>
      </div>{" "}
      <RefRemark remark={raw?.remark} />
    </>
  );
}
